import { useCallback, useState } from "react";
import useSetTokenState from "./useSetTokenState";
import axios from "../../../lib/axios";

function useUserLogin() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const setToken = useSetTokenState();

  const loginHandler = useCallback(
    async (loginEmail, loginPassword) => {
      setLoading(true);
      setError(false);

      try {
        const res = await axios.post("/api/auth/login", {
          email: loginEmail,
          password: loginPassword,
        });

        const data = res.data;
        const authToken = {
          email: loginEmail,
          accessToken: data?.access_token,
          expiresIn: data?.expires_in,
          tokenType: data?.token_type,
        };

        setToken(authToken);

        return data;
      } catch (error) {
        console.log(error.response);
        const status = error.response.status;
        if (status >= 400 && status <= 500) {
          setError("Wrong email or password.");
          return;
        }
        return error.response?.data?.errors;
      } finally {
        setLoading(false);
      }
    },
    [setToken]
  );

  return [loginHandler, loading, error];
}

export default useUserLogin;
